import React from 'react'
import Images from '../../assets/images';
import './Clients.css';
import { Grid } from '@mui/material';
import { t } from 'i18next';

const Clients = () => {
  const clientLogos = Object.values(Images.academy.clients)

  return (
    <Grid container className='clients desktop'>
      <p className='clients-label'>{t('academyIntro.label2')}</p>

      <div className='clients-track'>
        <div className='clients-group'>
          {clientLogos.map((item, index) => (
            <img key={`logo-a-${index}`} className='image' src={item} alt={`academy-client-${index + 1}`} />
          ))}
        </div>

        <div className='clients-group' aria-hidden='true'>
          {clientLogos.map((item, index) => (
            <img key={`logo-b-${index}`} className='image' src={item} alt='' />
          ))}
        </div>
      </div>
    </Grid>

  )
}

export default Clients 